// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton-D5U-3__wrapper","icon":"BackButton-DzVMK__icon"};